export function playGymAccessDenySound(): void {
  const AudioCtx =
    window.AudioContext ||
    (window as Window & { webkitAudioContext?: typeof AudioContext })
      .webkitAudioContext

  if (!AudioCtx) {
    return
  }

  const ctx = new AudioCtx()
  const oscillator = ctx.createOscillator()
  const gain = ctx.createGain()

  oscillator.type = 'square'
  oscillator.frequency.value = 180
  gain.gain.value = 0.08
  oscillator.connect(gain)
  gain.connect(ctx.destination)
  oscillator.start()
  gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.22)
  oscillator.stop(ctx.currentTime + 0.22)
  oscillator.onended = () => {
    void ctx.close()
  }
}
